import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCacheRecord } from 'gossamer-front-end';
import { InstitutionMember } from 'cb-model';

// redirect to user page

export const InstitutionMemberDisplay = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(InstitutionMember, params.key);
  React.useEffect(() => {
    // check that record is loaded and it is the correct record, then navigate to user page
    if (String(record.data?.id) === params.key) {
      navigate(`/admin/user/display/${record.data?.user_id}`, {
        replace: true,
      });
    }
  }, [record.data]);
  return null;
};
